import { useMutation } from '@tanstack/react-query';
import child_process from 'app/native/node/child_process';

const TOUCH_SCREEN_FIND_COMMAND_PART =
  "`$devices=Get-PnpDevice -PresentOnly -Class HIDClass;`$ids=(Get-PnpDeviceProperty -InstanceId `$devices.InstanceId -KeyName DEVPKEY_Device_DriverDesc -EA SilentlyContinue | Where-Object { `$_.Data -and `$_.Data.IndexOf('touch screen',[StringComparison]::OrdinalIgnoreCase) -ge 0 } | Select-Object -Expand InstanceId);`$devices | Where-Object InstanceId -in `$ids";

const TOUCH_SCREEN_DISABLE_COMMAND = [
  '-NoProfile',
  '-Command',
  `Start-Process powershell -Verb RunAs -Wait -WindowStyle Hidden -ArgumentList "-NoProfile -ExecutionPolicy Bypass -Command ${TOUCH_SCREEN_FIND_COMMAND_PART} | Disable-PnpDevice -Confirm:\`$false"`,
];
/*
$devices=Get-PnpDevice -PresentOnly -Class HIDClass;$ids=(Get-PnpDeviceProperty -InstanceId $devices.InstanceId -KeyName DEVPKEY_Device_DriverDesc -EA SilentlyContinue | Where-Object { $_.Data -and $_.Data.IndexOf('touch screen',[StringComparison]::OrdinalIgnoreCase) -ge 0 } | Select-Object -Expand InstanceId);$devices | Where-Object InstanceId -in $ids | Enable-PnpDevice -Confirm:$false
*/
const TOUCH_SCREEN_ENABLE_COMMAND = [
  '-NoProfile',
  '-Command',
  `Start-Process powershell -Verb RunAs -Wait -WindowStyle Hidden -ArgumentList "-NoProfile -ExecutionPolicy Bypass -Command ${TOUCH_SCREEN_FIND_COMMAND_PART} | Enable-PnpDevice -Confirm:\`$false"`,
];

export default function useSwitchTouchScreenMutation() {
  if (!child_process()) {
    return undefined;
  }

  return useMutation({
    mutationKey: ['switchTouchScreen'],
    mutationFn: async ({ enabled }: { enabled: boolean }) => {
      const command = enabled ? TOUCH_SCREEN_ENABLE_COMMAND : TOUCH_SCREEN_DISABLE_COMMAND;

      let output = '';
      let errorOutput = '';
      return new Promise<void>((resolve, reject) => {
        const process = child_process().spawn('powershell', command);
        process.stdout.on('data', (data) => {
          output += data;
        });
        process.stderr.on('data', (data) => {
          errorOutput += data;
        });
        process.on('exit', (code) => {
          console.log(`PowerShell process exited with code ${code}`);
          if (code === 0) {
            resolve();
          } else {
            reject(new Error(`PowerShell process failed with code ${code}`));
          }
        });
        process.on('error', (err) => {
          console.warn('Failed to start subprocess.', err);
          reject(err);
        });
      }).finally(() => {
        if (output) {
          console.log('SwitchTouchScreen output:', output);
        }
        if (errorOutput) {
          console.warn('SwitchTouchScreen error output:', errorOutput);
        }
      });
    },
  });
}
